import React from 'react';
import { SignableOfferForm } from '../..';
import { LoadingSpinner } from '../../../../../../components/LoadingSpinner';
import { Avatar } from '../../../../../../components/Avatar';
import { Col, Row } from 'reactstrap';
import { AttachmentDto } from '../../../../../../services/dtos/EmailDto';
import parse from 'html-react-parser';
import { domPurify, updateLinksToNewTab } from '../../../../../../utils/dom';
import { AttachmentInputList } from '../../../../../SendEmailModal/EmailModalBody/EmailFooter/AttachmentInputList';
import classNames from 'classnames';
import { AlertMessage } from '../../../../../../components/AlertMessage';
import { ApprovalFlowContainer } from '../../../../JobRequisitions/components/ApprovalFlowContainer';

interface PropTypes {
  emailAttachments: AttachmentDto[];
  emailHtml: string;
  isLoading: boolean;
  signableDocumentsNode: JSX.Element;
  signatoryName?: string;
  alertMessage?: string;
  applicationId?: number;
  className?: string;
  form?: SignableOfferForm;
  offerRequisitionFlowEnabled?: boolean;
}

export function CompanySignatory(props: { signatoryName: string }) {
  if (props.signatoryName == null) {
    return null;
  }

  return (
    <div>
      <span className='fw-semibold fs-5'>Company Signatory</span>
      <Row className='d-flex align-items-center gx-2h mt-2'>
        <Col className='d-flex col-auto'>
          <Avatar name={props.signatoryName} type='initials' size='md' />
          <span className='fs-5'>{props.signatoryName}</span>
        </Col>
      </Row>
    </div>
  );
}

export function EmailMessage(props: {
  emailMessageHtml: string;
  attachments: AttachmentDto[];
}) {
  return (
    <div>
      <span className='fw-semibold fs-5'>Email Message</span>
      <div className='mt-2 bg-gray border-1 p-3'>
        {parse(domPurify(updateLinksToNewTab(props.emailMessageHtml)))}
      </div>
      <AttachmentInputList attachments={props.attachments} />
    </div>
  );
}

function Summary(props: PropTypes) {
  return (
    <Col className='px-0'>
      {props.offerRequisitionFlowEnabled && (
        <>
          <h3>Offer Details</h3>
          <div className='fs-6 text-dark-200 mb-4'>
            Review the offer details before submitting
          </div>
        </>
      )}
      <div className='d-flex flex-column gap-4'>
        {props.alertMessage && (
          <AlertMessage
            icon={{ name: 'bi-info-circle' }}
            className='bg-yellow-light'
            textClassName='fs-5'
            text={props.alertMessage}
          />
        )}
        <div className='w-75'>{props.signableDocumentsNode}</div>
        <CompanySignatory signatoryName={props.signatoryName} />
        <EmailMessage
          emailMessageHtml={props.emailHtml}
          attachments={props.emailAttachments}
        />
      </div>
    </Col>
  );
}

export function OfferSummary(props: PropTypes) {
  return (
    <div
      className={classNames(props.className, 'px-4', 'mb-3', 'overflow-auto')}
    >
      {props.isLoading ? (
        <LoadingSpinner />
      ) : (
        <Row>
          <Summary {...props} />
          {props.offerRequisitionFlowEnabled && (
            <>
              <Col xs='6' className='border-start ps-5 ms-5 mb-2'>
                <ApprovalFlowContainer
                  requisitionType='offer'
                  applicationId={props.applicationId}
                />
              </Col>
            </>
          )}
        </Row>
      )}
    </div>
  );
}
